import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'polaris-components-quickstart.tasks.explore-the-basics.title.non-final',
		defaultMessage: 'Explore the basics',
		description: 'The title appears on the list of onboarding tasks in the sidebar',
	},
	description: {
		id: 'polaris-components-quickstart.tasks.explore-the-basics.description.non-final',
		defaultMessage:
			'Collect ideas, add structure with custom fields, and tailor views with filters to focus on what matters most to your team.',
		description:
			'The description appears on the expanded task item of onboarding quickstart sidebar below the title',
	},
	roleRestrictionsText: {
		id: 'polaris-components-quickstart.tasks.explore-the-basics.role-restrictions-text.non-final',
		defaultMessage: "Creators and contributors can't create or edit fields.",
		description: 'Text describing role restrictions',
	},
});
